import axios, { AxiosRequestConfig } from "axios";
import Cookies from "js-cookie";

const BASE_URL = `${process.env.REACT_APP_API_URL_AUTH}`;

const apiPostAuth = (
  url: string,
  data?: any, 
  responseType: "json" | "blob" = "json"
) => {
  const authCook = Cookies.get("access_token")
  const axiosConfig: AxiosRequestConfig = {
    withCredentials: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${authCook}`,
    },
    responseType, 
  };

  return axios.post(`${BASE_URL}${url}`, data, axiosConfig);
};

export default apiPostAuth;